import type { IDiaryData } from '@common/validation/holterDiary';
import { FilesUrlBase } from '@common/enums';
import { imageAndPdfExtensions } from '@common/utils/fileExtensions';
import { AssetsDropzone } from '@frontend/components/elements/dropzone/AssetsDropzone';
import type { ValidationErrors } from '../../../utils/validation';
import { getValidationError } from '../episodeCategory/customControls/processActivityAssets/ProcessActivityAssetsDropzone';

interface HolterReadUploadProps {
    assets: IDiaryData['assets'];
    errors: ValidationErrors;
    isUploading: (isUploading: boolean) => Promise<void>;
    onFilesChanged: (assets: IDiaryData['assets']) => Promise<void>;
    processActivityId?: string | null;
    processId?: string | null;
    requestId?: string | null;
}

export function HolterReadUpload(props: Readonly<HolterReadUploadProps>) {
    return (
        <div style={{ marginBottom: '0.75rem', marginTop: '0.75rem' }}>
            <AssetsDropzone
                acceptExtensions={imageAndPdfExtensions}
                assets={props.assets}
                key="dagboekje_upload"
                maxAssets={25}
                onChange={async (assets) => await props.onFilesChanged(assets)}
                onUploadComplete={async () => await props.isUploading(false)}
                onUploadStart={async () => await props.isUploading(true)}
                validationError={getValidationError({
                    error: props.errors.get('files'),
                    maxFiles: 25,
                    minFiles: 1,
                })}
                viewerId={props.requestId ?? props.processActivityId ?? props.processId ?? undefined}
                viewerUrlBase={props.requestId ? FilesUrlBase.requests : FilesUrlBase.processActivities}
            />
        </div>
    );
}
